/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Circle, CircleFill } from 'react-bootstrap-icons'
import Patient from '../../../../../libs/api/services/Patient'
import WorkFlow from '../../../../../libs/api/services/WorkFlow'
export default function EventTriggerPatientProfileOptions({ link, values }) {
    const [patientProfiles, setPatientProfiles] = useState([])
    const [linked, setLinked] = useState([])
    const [properties, setProperties] = useState([])


    useEffect(() => {
        loadPatientProfiles()
    }, [])

    const _loadLinks = () => {
        try {
            WorkFlow
                .GetTriggerPropertyByType(typeof values.event === 'object' ? values.event.id : JSON.parse(values.event).id, link[0].id, 'categories')
                .then((r) => {
                    setLinked(JSON.parse(r.value))
                }).catch((e) => { /* Doesnt exist yet */ })
        } catch (e) {
            // Not yet linked
        }
    }

    const loadPatientProfiles = () => {
        Patient
            .Categories()
            .then((r) => {
                setPatientProfiles(r)
                _loadLinks()
            })
    }
    const setPatientProfileLink = (cat) => {
        var _linked = []
        var _add = true
        for (const _l of linked)
            if (_l.id === cat.id)
                _add = false
            else
                _linked.push(_l)
        if (_add)
            _linked.push(cat)
        WorkFlow
            .SetTriggerProperty(typeof values.event === 'object' ? values.event.id : JSON.parse(values.event).id, link[0].id, {
                property: 'categories',
                value: JSON.stringify(_linked),
            })
            .then((r) => {
                // Log as property
                setLinked(_linked)
            })
    }

    const _isLinekd = (id) => {
        for (const l of linked)
            if (l.id === id) return true
        return false
    }

    return (
        <div>
            <b>Select the category you would like to add this event to</b>
            {
                patientProfiles.map((c) =>
                    <div onClick={(e) => setPatientProfileLink(c)} key={c.resource.id} className='ms-2'>{_isLinekd(c.resource.id) ? <CircleFill className='me-2' /> : <Circle className='me-2' />} {c.resource.groupNme}</div>
                )
            }
        </div>
    )
}
